import React from 'react'
import { UserProvider } from 'pobble-components/dist/pobble-user'
import { withRouter } from 'react-router'
import SignOutProcess from './sign-out-process/sign-out-process.container'
import { apiGetMe } from '../../../common/api/profile'

const getMe = () => apiGetMe({ include: 'account.student_type' })

const SignOut = () => (
  <UserProvider fetchMe={getMe}>
    <SignOutProcess />
  </UserProvider>
)

export default withRouter(SignOut)
